module.exports = __webpack_public_path__ + "static/hero-plus-c3dffbdd2f331cfa42fb37ecfde8ecbd.png";